/**
 * Hook que carrega os 16 planos da API e organiza por nível para a landing page.
 *
 * O frontend escolhe modalidade (Individual/Coletivo) e ciclo (Mensal/Anual)
 * via toggle, e este hook devolve os 4 planos do nível correspondente.
 */
import { useEffect, useState } from 'react';
import {
  CicloPagamento,
  ModalidadePlano,
  Plano,
  planosApi,
} from '../api/planos';

interface PlanosFiltrados {
  loading: boolean;
  error: string | null;
  bronze: Plano | null;
  prata: Plano | null;
  ouro: Plano | null;
  diamante: Plano | null;
}

export function usePlanos(
  modalidade: ModalidadePlano,
  ciclo: CicloPagamento,
): PlanosFiltrados {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [planos, setPlanos] = useState<Plano[]>([]);

  useEffect(() => {
    let cancelado = false;
    setLoading(true);
    setError(null);
    planosApi
      .list({ modalidade, ciclo })
      .then((data) => {
        if (!cancelado) {
          setPlanos(data);
          setLoading(false);
        }
      })
      .catch((err) => {
        if (!cancelado) {
          setError(err.message || 'Falha ao carregar planos');
          setLoading(false);
        }
      });
    return () => {
      cancelado = true;
    };
  }, [modalidade, ciclo]);

  return {
    loading,
    error,
    bronze: planos.find((p) => p.nivel === 'bronze') ?? null,
    prata: planos.find((p) => p.nivel === 'prata') ?? null,
    ouro: planos.find((p) => p.nivel === 'ouro') ?? null,
    diamante: planos.find((p) => p.nivel === 'diamante') ?? null,
  };
}
